import { AuthorizationChildNode } from './../models/authorization.child-node';
import { AuthorizationTree } from './../models/authorization.tree';
import { Authorization } from './../models/authorization';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class AuthorizationService {
    authorizationUrl = 'api/authorization';
    constructor(private _authHttp: RestApi) { }

    getParentsTree(): Observable<AuthorizationTree[]> {
        return this._authHttp.get(`${this.authorizationUrl}`);
    }

    getAuthorizationDetail(type: string, subType: string, nodeId: Guid): Observable<IAuthorizationDetail> {
        if(!subType || subType === '') {
            return this._authHttp.get(`${this.authorizationUrl}/${type}/${nodeId}/`);
        }
        else {
            return this._authHttp.get(`${this.authorizationUrl}/${type}/${subType}/${nodeId}/`);
        }
    }

    getChildNodesByType(type: string): Observable<AuthorizationChildNode[]> {
        return this._authHttp.get(`${this.authorizationUrl}/${type}/`);
    }

    putDataDetail(type: string, id: Guid, body: any): Observable<any> {
        return this._authHttp.post(`${this.authorizationUrl}`, body);
    }
}
